module.exports = __webpack_public_path__ + "static/media/microsoft-1-scan-qr.82561f60.png";